import { create } from 'zustand';

/**
 * Shared page-chrome state between the header and the footer, which are
 * siblings rendered per-page with no common provider to pass props through.
 *
 * Only one Ugandan flag rule should be on screen at a time: the header carries
 * it while you read, and hands it over to the footer once the footer's own
 * rule scrolls into view.
 */
interface ChromeState {
  isFooterRuleVisible: boolean;
  setFooterRuleVisible: (visible: boolean) => void;
}

export const useChromeStore = create<ChromeState>((set) => ({
  isFooterRuleVisible: false,
  setFooterRuleVisible: (visible: boolean) => set({ isFooterRuleVisible: visible }),
}));
